// @ts-nocheck
export default function Overlays() {
  return (
    <>
<div id="grain"></div>
<div id="sp"><div id="spf"></div></div>


    </>
  );
}
